import CityPageTemplate from "../city-template/CityPageTemplate";
import { sanAntonioConfig } from "./data";

export default function SanAntonioPage() {
  return <CityPageTemplate config={sanAntonioConfig} />;
}